import React from 'react';
import PropTypes from 'prop-types';

export const CrossLobRecommend = ({ label, url, idx }) => (
  <li key={label + idx} className="appendBottom10">
    <a href={url} className="font14 darkGreyText railSeoWrap__rwStnListLink">
      {label}
    </a>
  </li>
);

CrossLobRecommend.propTypes = {
  label: PropTypes.string,
  idx: PropTypes.number,
  url: PropTypes.string
};

export default CrossLobRecommend;
